import { Injectable } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Observable, of ,  Observer } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class EditguarddialogService {
  constructor() { }
  confirm(message?: string, confirmationService?: ConfirmationService): Observable<boolean> {  
    if (confirmationService !== undefined) {
      return Observable.create((observer: Observer<boolean>) => {
        confirmationService.confirm({
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          message: message,
          accept: () => {
            observer.next(true);
            observer.complete();
          },
          reject: () => {
            observer.next(false);
            observer.complete();
          }
        });
      });
    }
    else {
      const confirmation = window.confirm(message || 'You are attempting to leave the page without saving.  Click OK to leave or cancel to complete your changes.');
      return of(confirmation);
    }
  };
 
}